import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { Checkbox, ListItem, ListItemText, Typography } from '@mui/material'
import { colors } from 'src/theme'

interface Props {
  value: string
  label?: string
  isVisible: boolean
  isLocked?: boolean
  onToggleVisibility(value: string): void
}

const GridColumnsSelectItemComponent = ({
  value,
  label,
  isVisible,
  isLocked = false,
  onToggleVisibility,
}: Props) => {
  const handleChange = useCallback(() => {
    if (isLocked) {
      return
    }

    onToggleVisibility(value)
  }, [value, isLocked, onToggleVisibility])

  return (
    <ListItem css={tw`w-full h-9 px-2 cursor-pointer`} disablePadding onClick={handleChange}>
      <Checkbox
        size="small"
        checked={isVisible}
        disabled={isLocked}
        onChange={handleChange}
        css={tw`p-1 mr-1`}
        onClick={(clickEvent) => {
          clickEvent.stopPropagation()
        }}
        sx={{
          color: 'black',
          '&.Mui-checked': { color: 'black' },
        }}
      />
      <ListItemText
        id={`list-label-${value}`}
        primary={
          <Typography
            variant="body2"
            color={isLocked ? colors.GRAY_MID_COOL : colors.GRAY_COOL_GRAY}
          >
            {label}
          </Typography>
        }
      />
    </ListItem>
  )
}

export const GridColumnsSelectItem = memo(GridColumnsSelectItemComponent)
